const getComponents = (doc, isCsv = false) => {
  const contentIsArray = Array.isArray(doc.content);
  const headline = contentIsArray
    ? doc.content[0]
      .replace(/(<([^>]+)>)/gi, '')
      .split(/\r?\n/)[0]
      .trim()
    : 'Try Today';
  const linkDescription = contentIsArray
    ? doc.content[1]
      .replace(/(<([^>]+)>)/gi, '')
      .split(/\r?\n/)[0]
      .trim()
    : 'Over 1000 5-star reviews';
  let mainContent = contentIsArray
    ? doc.content[2].replace(/(<([^>]+)>)/gi, '').trim()
    : doc.content.replace(/(<([^>]+)>)/gi, '').trim();

  if (isCsv) {
    mainContent = mainContent.replace(',', '%2');
  }
  return {
    headline,
    linkDescription,
    mainContent,
  };
};

const getClipboardItem = (doc) => `${doc.content[0].replace('\n', '')} | ${doc.content[1].replace('\n', '')} | ${doc.content[2]}`.replace(/(<([^>]+)>)/ig, '');

const getCsvContent = (docs) => docs.reduce((csv, doc) => {
  const { headline, linkDescription, mainContent } = getComponents(doc, true);
  return `${csv}"${headline}"~"${linkDescription}"~"${mainContent}"\r\n`;
}, '');

const getPdfContent = (docs) => docs.reduce((pdf, doc) => {
  const { headline, linkDescription, mainContent } = getComponents(doc);
  return `${pdf}${headline}\n${mainContent}\n${linkDescription}\r\n\n`;
}, '');

const getTxtContent = (docs) => docs.reduce((txt, doc) => {
  const { headline, linkDescription, mainContent } = getComponents(doc);
  return `${txt}${headline}\n${mainContent}\n${linkDescription}\r\n\n`;
}, '');

export {
  getTxtContent, getPdfContent, getCsvContent, getClipboardItem,
};
